import './component';
import './preview';

Shopware.Service('cmsService').registerCmsElement({
    name: 'manufacturer-element',
    label: 'manufacturer-pages.cms.elementLabel',
    component: 'sw-cms-element-manufacturer-component',
    previewComponent: 'sw-cms-element-manufacturer-preview'
});
